/**
 * All measurement text in the plan goes through here, so feet-and-inches and
 * metric can never drift apart. Internally the editor works in pixels, at
 * METER pixels to the metre; that stays the source of truth.
 */
import { METER } from "./constants";
import { useUnitStore } from "../../stores/UnitStore";

const FEET_PER_METER = 3.280839895013123;

export function pixelsToMeters(pixels: number) {
    return Math.abs(pixels) / METER;
}

export function metersToPixels(meters: number) {
    return meters * METER;
}

/** Splits a length into whole feet plus inches rounded to the nearest inch. */
export function metersToFeetInches(meters: number) {
    const totalInches = Math.round(Math.abs(meters) * FEET_PER_METER * 12);
    return { feet: Math.floor(totalInches / 12), inches: totalInches % 12 };
}

export function feetInchesToMeters(feet: number, inches: number) {
    return ((feet || 0) * 12 + (inches || 0)) / 12 / FEET_PER_METER;
}

export function formatMeters(meters: number) {
    if (useUnitStore.getState().unit === 'metric') {
        return (Math.round(meters * 100) / 100).toFixed(2) + " m";
    }
    const { feet, inches } = metersToFeetInches(meters);
    return inches === 0 ? `${feet}'` : `${feet}' ${inches}"`;
}

export function formatLength(pixels: number) {
    return formatMeters(pixelsToMeters(pixels));
}
